module.exports = __webpack_public_path__ + "certificaat_les_1_lllmbo.pdf";